(function () {
  'use strict';

  if (window.CMFlipbook) {
    window.CMFlipbook.scan(document);
    return;
  }

  var controllers = new WeakMap();
  var pending = new WeakMap();

  function replaceCounterTokens(template, first, second, total) {
    var label = template.replace('[x]', String(first)).replace('[y]', String(second));

    return typeof total === 'undefined' ? label : label.replace('[z]', String(total));
  }

  function markFailed(root) {
    var fallback = root.querySelector('[data-cm-flipbook-fallback]');
    var viewer = root.querySelector('[data-cm-flipbook-viewer]');

    if (viewer) viewer.remove();
    if (fallback) {
      fallback.hidden = false;
      fallback.classList.add('is-error');
    }
    root.dataset.cmFlipbookState = 'failed';
  }

  function destroy(root) {
    var waiting = pending.get(root);
    var controller = controllers.get(root);

    if (waiting) {
      window.clearTimeout(waiting.timer);
      pending.delete(root);
    }

    if (!controller) return;

    window.removeEventListener('resize', controller.onResize);
    if (controller.resizeFrame) window.cancelAnimationFrame(controller.resizeFrame);

    try {
      controller.pageFlip.destroy();
    } catch (error) {
      // Die Section wird ohnehin entfernt; ein Fehler beim Aufräumen darf den Editor nicht blockieren.
    }

    controllers.delete(root);
  }

  function build(root) {
    if (!root.isConnected || controllers.has(root)) return;

    var viewer = root.querySelector('[data-cm-flipbook-viewer]');
    var book = root.querySelector('[data-cm-flipbook-book]');
    var fallback = root.querySelector('[data-cm-flipbook-fallback]');
    var previous = root.querySelector('[data-cm-flipbook-prev]');
    var next = root.querySelector('[data-cm-flipbook-next]');
    var counter = root.querySelector('[data-cm-flipbook-counter]');
    var zoom = root.querySelector('[data-cm-flipbook-zoom]');
    var dialog = root.querySelector('[data-cm-flipbook-dialog]');
    var dialogImage = root.querySelector('[data-cm-flipbook-dialog-image]');
    var dialogPrevious = root.querySelector('[data-cm-flipbook-dialog-prev]');
    var dialogNext = root.querySelector('[data-cm-flipbook-dialog-next]');
    var dialogCounter = root.querySelector('[data-cm-flipbook-dialog-counter]');
    var pages = book ? book.querySelectorAll('[data-cm-flipbook-page]') : [];

    if (!viewer || !book || !fallback || !previous || !next || !counter || !zoom || !dialog ||
        !dialogImage || !dialogPrevious || !dialogNext || !dialogCounter || !pages.length) {
      markFailed(root);
      return;
    }

    viewer.hidden = false;
    viewer.classList.add('is-initializing');

    try {
      var startPage = Math.max(0, Math.min(pages.length - 1, Number(root.dataset.startPage) - 1));
      var maxViewerWidth = Math.max(900, Math.min(1600, Number(root.dataset.viewerMaxWidth) || 1400));
      var maxPageWidth = maxViewerWidth / 2;
      var maxPageHeight = Math.round(maxPageWidth * 1727 / 1216);
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      root.dataset.flippingTime = reducedMotion ? '1' : '900';
      var pageFlip = new window.St.PageFlip(book, {
        width: 704,
        height: 1000,
        size: 'stretch',
        minWidth: 220,
        maxWidth: maxPageWidth,
        minHeight: 200,
        maxHeight: maxPageHeight,
        startPage: startPage,
        drawShadow: true,
        flippingTime: reducedMotion ? 1 : 900,
        usePortrait: true,
        autoSize: true,
        maxShadowOpacity: 0.34,
        showCover: false,
        mobileScrollSupport: true,
        swipeDistance: 28,
        clickEventForward: true,
        useMouseEvents: true,
        showPageCorners: true,
        disableFlipByClick: false
      });
      var controller = {
        pageFlip: pageFlip,
        zoomIndex: startPage,
        resizeFrame: 0,
        onResize: null
      };

      controllers.set(root, controller);

      function updateControls(pageIndex) {
        var total = pageFlip.getPageCount();
        var current = Math.max(0, Math.min(total - 1, Number(pageIndex)));
        var isLandscape = pageFlip.getOrientation() === 'landscape';

        if (isLandscape) {
          // Bei showCover:false beginnen Spreads mit geraden Indizes; mit Cover wäre die Parität versetzt.
          var left0 = current - (current % 2);
          var firstVisible = left0 + 1;
          var lastVisible = Math.min(left0 + 2, total);

          previous.disabled = firstVisible <= 1;
          next.disabled = lastVisible >= total;
          counter.textContent = replaceCounterTokens(
            root.dataset.counterRangeLabel,
            firstVisible,
            lastVisible,
            total
          );
          return;
        }

        previous.disabled = current === 0;
        next.disabled = current === total - 1;
        counter.textContent = replaceCounterTokens(root.dataset.counterLabel, current + 1, total);
      }

      function onPrevious() {
        if (!previous.disabled) pageFlip.flipPrev();
      }

      function onNext() {
        if (!next.disabled) pageFlip.flipNext();
      }

      function updateDialog(pageIndex) {
        var total = pageFlip.getPageCount();
        var current = Math.max(0, Math.min(total - 1, Number(pageIndex)));
        var source = pages[current].querySelector('img');

        controller.zoomIndex = current;
        dialogImage.src = source.currentSrc || source.src;
        dialogImage.alt = source.alt;
        dialogPrevious.disabled = current === 0;
        dialogNext.disabled = current === total - 1;
        dialogCounter.textContent = replaceCounterTokens(root.dataset.counterLabel, current + 1, total);
      }

      function openDialog() {
        var current = pageFlip.getCurrentPageIndex();

        if (pageFlip.getOrientation() === 'landscape') current -= current % 2;
        updateDialog(current);
        dialog.showModal();
      }

      function showDialogPage(offset) {
        var target = controller.zoomIndex + offset;

        if (target < 0 || target >= pageFlip.getPageCount()) return;
        updateDialog(target);
        pageFlip.turnToPage(target);
        updateControls(target);
      }

      function onKeydown(event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          onPrevious();
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          onNext();
        }
      }

      function onDialogKeydown(event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          showDialogPage(-1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          showDialogPage(1);
        }
      }

      function onDialogBackdrop(event) {
        if (event.target === dialog) dialog.close();
      }

      controller.onResize = function () {
        if (controller.resizeFrame) window.cancelAnimationFrame(controller.resizeFrame);
        controller.resizeFrame = window.requestAnimationFrame(function () {
          pageFlip.update();
          controller.resizeFrame = 0;
        });
      };

      previous.addEventListener('click', onPrevious);
      next.addEventListener('click', onNext);
      zoom.addEventListener('click', openDialog);
      dialogPrevious.addEventListener('click', function () { showDialogPage(-1); });
      dialogNext.addEventListener('click', function () { showDialogPage(1); });
      dialog.addEventListener('keydown', onDialogKeydown);
      dialog.addEventListener('click', onDialogBackdrop);
      viewer.addEventListener('keydown', onKeydown);
      window.addEventListener('resize', controller.onResize);

      pageFlip.on('flip', function (event) {
        updateControls(event.data);
      });

      pageFlip.on('changeOrientation', function () {
        updateControls(pageFlip.getCurrentPageIndex());
      });

      pageFlip.on('init', function (event) {
        fallback.hidden = true;
        viewer.classList.remove('is-initializing');
        viewer.classList.add('is-ready');
        viewer.setAttribute('aria-busy', 'false');
        root.dataset.cmFlipbookState = 'ready';
        updateControls(event.data.page);
        window.requestAnimationFrame(function () {
          pageFlip.update();
        });
      });

      pageFlip.loadFromHTML(pages);
    } catch (error) {
      destroy(root);
      markFailed(root);
    }
  }

  function waitForPageFlip(root, attempt) {
    if (!root.isConnected) return;

    if (window.St && typeof window.St.PageFlip === 'function') {
      pending.delete(root);
      build(root);
      return;
    }

    if (attempt >= 100) {
      pending.delete(root);
      markFailed(root);
      return;
    }

    var timer = window.setTimeout(function () {
      waitForPageFlip(root, attempt + 1);
    }, 50);
    pending.set(root, { timer: timer });
  }

  function schedule(root, attempt) {
    if (!root || root.dataset.cmFlipbookScheduled === 'true') return;

    if (typeof window.initLazyScript === 'function') {
      root.dataset.cmFlipbookScheduled = 'true';
      window.initLazyScript(root, function () {
        waitForPageFlip(root, 0);
      });
      return;
    }

    root.dataset.cmFlipbookScheduled = 'true';
    waitForPageFlip(root, 0);
  }

  function scan(scope) {
    if (scope.matches && scope.matches('[data-cm-flipbook-root]')) schedule(scope, 0);
    scope.querySelectorAll('[data-cm-flipbook-root]').forEach(function (root) {
      schedule(root, 0);
    });
  }

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-cm-flipbook-root]');
    if (root) destroy(root);
  });

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });

  window.CMFlipbook = {
    destroy: destroy,
    scan: scan
  };

  scan(document);
}());
